import { render, staticRenderFns } from "./StockInfo.html?vue&type=template&id=b020e18e&scoped=true&"
import script from "./StockInfo.js?vue&type=script&lang=js&"
export * from "./StockInfo.js?vue&type=script&lang=js&"
import style0 from "./StockInfo.scss?vue&type=style&index=0&id=b020e18e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b020e18e",
  null
  
)

export default component.exports